import { useFeature } from '../../store/hooks/useFeature';
import { Features } from '../../models/features';
import { isUndefined } from 'util';

export type FeatureToggleProps =
  & {
    whenFlag: Features;
    children: JSX.Element | false;
  }
  & (
    | { isEnabled: boolean; isDisabled?: undefined; }
    | { isEnabled?: undefined; isDisabled: boolean; }
  );

// tslint:disable-next-line:variable-name
export const FeatureToggle = ({ children, whenFlag, isEnabled, isDisabled }: FeatureToggleProps) => {
  const { value, isLoading } = useFeature(whenFlag);

  const useFeatureWhen = isUndefined(isDisabled) ? isEnabled : !isDisabled;

  if (!children || isLoading || useFeatureWhen !== value) {
    return null;
  }

  return children;
};
